import type { Warning } from '../../../assessment/types';
import s from '../styles/dashboard.module.css';

const TAG: Record<Warning['severity'], string> = {
  high: 'Critical',
  medium: 'Caution',
  low: 'Note',
};

const TAG_CLASS: Record<Warning['severity'], string> = {
  high: s.warningTagHigh,
  medium: s.warningTagMedium,
  low: s.warningTagLow,
};

const SEVERITY_RANK: Record<Warning['severity'], number> = {
  high: 3,
  medium: 2,
  low: 1,
};

const BAR_CLASS: Record<Warning['severity'], string> = {
  high: s.warningsHigh,
  medium: s.warningsMedium,
  low: s.warningsLow,
};

interface Props {
  warnings: Warning[];
}

const WarningsList = ({ warnings }: Props) => {
  if (warnings.length === 0) return null;
  const top = warnings.reduce((acc, w) =>
    SEVERITY_RANK[w.severity] > SEVERITY_RANK[acc.severity] ? w : acc,
  );

  return (
    <section className={`${s.card} ${s.warnings} ${BAR_CLASS[top.severity]}`}>
      {warnings.map((w, i) => (
        <div key={i} className={s.warningRow}>
          <span className={`${s.warningTag} ${TAG_CLASS[w.severity]}`}>
            {TAG[w.severity]}
          </span>
          <span className={s.warningBody}>{w.message}</span>
        </div>
      ))}
    </section>
  );
};

export default WarningsList;
